// Beneficiary Redux Reducer

// Action Types
export const BENEFICIARY_ACTIONS = {
  SET_BENEFICIARY_DATA: 'SET_BENEFICIARY_DATA',
  UPDATE_BENEFICIARY_FIELD: 'UPDATE_BENEFICIARY_FIELD',
  RESET_BENEFICIARY_DATA: 'RESET_BENEFICIARY_DATA',
  SET_BENEFICIARY_LOADING: 'SET_BENEFICIARY_LOADING',
  SET_BENEFICIARY_ERRORS: 'SET_BENEFICIARY_ERRORS',
  CLEAR_BENEFICIARY_ERRORS: 'CLEAR_BENEFICIARY_ERRORS',
};

// Initial State
const initialState = {
  beneficiaryData: {
    insurance_id: '',
    firm_type: '',
    firm_owner_name: '',
    id_type: '',
    id_number: '',
    full_name: '',
    dob: '',
    age: '',
    phone_number: '',
    confirm: false,
    gender: '',
  },
  loading: false,
  errors: {},
};

// Action Creators
export const setBeneficiaryData = (data) => ({
  type: BENEFICIARY_ACTIONS.SET_BENEFICIARY_DATA,
  payload: data,
});

export const updateBeneficiaryField = (field, value) => ({
  type: BENEFICIARY_ACTIONS.UPDATE_BENEFICIARY_FIELD,
  payload: { field, value },
});

export const resetBeneficiaryData = () => ({
  type: BENEFICIARY_ACTIONS.RESET_BENEFICIARY_DATA,
});

export const setBeneficiaryLoading = (loading) => ({
  type: BENEFICIARY_ACTIONS.SET_BENEFICIARY_LOADING,
  payload: loading,
});

export const setBeneficiaryErrors = (errors) => ({
  type: BENEFICIARY_ACTIONS.SET_BENEFICIARY_ERRORS,
  payload: errors,
});

export const clearBeneficiaryErrors = () => ({
  type: BENEFICIARY_ACTIONS.CLEAR_BENEFICIARY_ERRORS,
});

// Reducer
const beneficiaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case BENEFICIARY_ACTIONS.SET_BENEFICIARY_DATA:
      return {
        ...state,
        beneficiaryData: {
          ...state.beneficiaryData,
          ...action.payload,
        },
      };

    case BENEFICIARY_ACTIONS.UPDATE_BENEFICIARY_FIELD:
      return {
        ...state,
        beneficiaryData: {
          ...state.beneficiaryData,
          [action.payload.field]: action.payload.value,
        },
      };

    case BENEFICIARY_ACTIONS.RESET_BENEFICIARY_DATA:
      return {
        ...state,
        beneficiaryData: {
          ...initialState.beneficiaryData,
        },
        errors: {},
      };

    case BENEFICIARY_ACTIONS.SET_BENEFICIARY_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case BENEFICIARY_ACTIONS.SET_BENEFICIARY_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };

    case BENEFICIARY_ACTIONS.CLEAR_BENEFICIARY_ERRORS:
      return {
        ...state,
        errors: {},
      };

    case 'RESET_BENEFICIARY_NOMINEE':
      return {
        ...state,
        // Only reset nominee-related fields, preserve beneficiary data
        // This allows navigation between beneficiary pages without losing OCR data
        errors: {},
      };

    default:
      return state;
  }
};

export default beneficiaryReducer;